import { type FC } from 'react';
import { useCommentPreview } from '@/components/inspector/comments/use-comment-preview';
import { Label, LabelVariants } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';

const MAX_COMMENT_PREVIEW_LINES = 6;

export const CommentBody: FC<{ isTombstone: boolean; isReply: boolean; body: string | null | undefined }> = ({
  isTombstone,
  isReply,
  body,
}) => {
  const tComments = useTranslations('inspector.comments');
  const normalizedBody = isTombstone
    ? isReply
      ? tComments('deletedReplyPlaceholder')
      : tComments('deletedCommentPlaceholder')
    : (body ?? '');
  const { containerRef, contentRef, displayedBody, shouldClamp, expand } = useCommentPreview({
    body: normalizedBody,
    maxLines: MAX_COMMENT_PREVIEW_LINES,
  });

  return (
    <div ref={containerRef} className="relative flex flex-col gap-y-3">
      <p
        ref={contentRef}
        className={cn('whitespace-pre-wrap text-xs font-medium text-text-gray wrap-anywhere', isTombstone && 'italic')}
      >
        {displayedBody}
      </p>
      {shouldClamp && (
        <button type="button" className="w-fit" onClick={expand}>
          <Label
            variant={LabelVariants.INSPECTOR_SECTION}
            className="text-highlight-base hover:text-highlight-hover-color"
          >
            {tComments('readMore')}
          </Label>
        </button>
      )}
    </div>
  );
};
